module.exports = __webpack_public_path__ + "static/media/barbegal_muehlen.b4c4957b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/barbegal_muehlen.png
// module id = 709
// module chunks = 0